module.exports = __webpack_public_path__ + "static/media/home-vip.787d453d.svg";